import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import VirtualDropdown from "common/components/VirtualDropdown/VirtualDropdown"
import useContactos from "features/Contactos/hooks/useContactos"
import mapContactoFromApi from "features/Contactos/mappers/mapContactoFromApi"
import { setIsSelectFilterActive } from "features/Contactos/redux/slices/contactoSlice"
import { setLibrado } from "features/Crear/redux/slices/newDocumentoSlice"
import { Formik } from "formik"
import { useDispatch } from "hooks/useDispatch"
import { useCallback, useEffect } from "react"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"
import { INITIAL_QUERY_PARAMETERS } from "./constants"

const clienteSearchSchema = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    clienteSelected: Yup.object().required(t("errors.clientSelect")),
  })

const initialValues = {
  clienteSearch: "",
  clienteSelected: null,
}

const LibradoSearchForm = ({
  handleSelectCliente,
  cliente,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const {
    toggleShowCreateContacto,
    contactosBySelect,
    getContactosBySelect,
    fetchingContactosBySelect,
    totalCount,
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  } = useContactos()

  const dispatch = useDispatch()

  const eliminarDatosFacturaCliente = () => {
    JSON.parse(
      // @ts-expect-error TS(2345): Argument of type 'void' is not assignable to param...
      sessionStorage.setItem(
        "factura_dto",
        JSON.stringify({ type: false, dto: {} })
      )
    )
  }

  const onHandleScroll = (queryParams: $TSMigrationFixMe) => {
    getContactosBySelect(queryParams)
  }

  // @ts-expect-error TS(7030): Not all code paths return a value.
  const handleDatosClienteFactura = useCallback(async () => {
    // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable...
    const isNextDoc = JSON.parse(sessionStorage.getItem("factura_dto"))
    if (!isNextDoc) return false
    if (isNextDoc.type === false) return false

    const dir = {
      calle: isNextDoc.dto.librado.direccion,
      codigoPostal: isNextDoc.dto.librado.cp,
      poblacionId: isNextDoc.dto.librado.poblacionId,
      provinciaNombre: isNextDoc.dto.librado.provincia,
      poblacionNombre: isNextDoc.dto.librado.poblacion,
    }

    isNextDoc.dto.librado.direccion = dir

    const mappedLibrado = mapContactoFromApi(isNextDoc.dto.librado)
    dispatch(setLibrado(mappedLibrado))

    await eliminarDatosFacturaCliente()
  }, [dispatch])

  useEffect(() => {
    handleDatosClienteFactura()
  }, [handleDatosClienteFactura])

  const handleCreateLibrado = () => {
    const paginationNeeded = true
    const isCliente = true
    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    toggleShowCreateContacto(paginationNeeded, isCliente)
  }

  return (
    // @ts-expect-error TS(2741): Property 'onSubmit' is missing in type '{ children...
    <Formik
      initialValues={initialValues}
      validationSchema={clienteSearchSchema(t)}
    >
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div className='p-3 p-fluid p-formgrid p-grid'>
            <div className='pr-0 p-field p-col-12'>
              <label id='clienteSearch'>
                {t("crear.facturaRec.selectClienteLabel")}
              </label>
              <VirtualDropdown
                filter
                options={contactosBySelect || []}
                onChange={(e: $TSMigrationFixMe) =>
                  handleSelectCliente(e, cliente)
                }
                placeholder={t("crear.facturaRec.placeholderSearch")}
                emptyFilterMessage={t("crear.facturaRec.emptyMsg")}
                emptyMessage={t("crear.facturaRec.emptyMsg")}
                id='select-id'
                handleOnScroll={onHandleScroll}
                loading={fetchingContactosBySelect}
                startPage={20}
                fetchCallback={getContactosBySelect}
                initialQueryParameters={INITIAL_QUERY_PARAMETERS}
                setIsSelectFilterActive={setIsSelectFilterActive}
                totalCount={totalCount}
                userKey='librado'
              />
            </div>
            <span
              onClick={handleCreateLibrado}
              className='cursor-pointer text-gedesco'
            >
              <FontAwesomeIcon icon={["fal", "plus"]} />{" "}
              {t("crear.facturaRec.addNewClientLabel")}
            </span>
          </div>
          <input
            type='text'
            autoComplete='on'
            value=''
            style={{
              display: "none",
              opacity: 0,
              position: "absolute",
              left: "-100000px",
            }}
            readOnly
          />
        </form>
      )}
    </Formik>
  )
}

export default LibradoSearchForm
